export const ADDED = "books/addBook";
export const LOADED = "books/loadBook";
export const UPDATED = "books/updateBook";
export const DELETED = "books/deleteBook";
